import { Injectable } from '@angular/core';

interface LabServicesResponse {
  callback: string;
  result_object: any;
  result: any;
  error?: string;
}

@Injectable({
  providedIn: 'root',
})
export class LabServicesResource {
  // eslint-disable-next-line class-methods-use-this
  evaluate(data: any): Promise<LabServicesResponse> {
    return window
      .fetch(process.env.CONSOLE_URL, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => response.json())
      .catch((error) => ({ error }));
  }
}
